import React from 'react'

export default function CarDetails(props){
    
    return (
        <div className="popup-box" style={{zIndex:1000}}>
            <div className="box">
                <div style={{width:'30%', display:'inline-block', verticalAlign:'top'}}>
                    <span className="close-icon" onClick={props.handleClose}>x</span>
                    <h1>Maker: {props.data.Manufacturer} </h1>
                    <h1>Model: {props.data.Model} </h1>
                    <h1>Price: ${props.data.Price} </h1>
                    <h1>Year: {props.data.Year} </h1>
                    <h1>Type: {props.data.FuelType} </h1>
                    <h1>Body: {props.data.BodyStyle} </h1>
                    {props.data.ElectricRange ? <h1>Electric Range: {props.data.ElectricRange} </h1> : null}
                    {props.data.BatterySize ? <h1>Battery Size: {props.data.BatterySize} </h1> : null}
                </div>
                <img src={('http://polarize.info:5000/static/'+props.data.Manufacturer + props.data.Model + props.data.Year+'.jpg').replace(/\s+/g, '')}
                    alt={"A " + props.data.Manufacturer + " " + props.data.Model + " " + props.data.Year} style={{width:'70%', display:'inline-block'}}></img>
            </div>
        </div>
    );
}
    

